import { render, staticRenderFns } from "./TuitionMassNotificationList.vue?vue&type=template&id=19a54a4d&"
import script from "./TuitionMassNotificationList.vue?vue&type=script&lang=js&"
export * from "./TuitionMassNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./TuitionMassNotificationList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports